$(function (){

    //Load js date range
    date_range_picker();
    date_range_picker_full();
    date_range_picker_single();
    date_range_picker_single_dropdown();
    date_range_picker_single_time_picker();
    date_range_report_picker();
    date_range_filter_option();
    multiselectCheckbox();

    //Load js Modal
    $(".modal").on("show.coreui.modal", function(event){
        var button = $(event.relatedTarget);
        var action = button.attr('data-remote');
        var modal  = $(this);
        if (typeof action !== 'undefined' && action !== ''){
            modal.find(".modal-content").load(action);
        }
    });

    //Check All
    $(".check_all").click(function () {
        $(".check").prop('checked', $(this).prop('checked')).change();
    });

    ////Keep Open Dropdown
    $('body').on("click", ".dropdown-menu-keep-open", function (e) {
        $(this).parent().is(".show") && e.stopPropagation();
    });

    //Load % thông tin
    $(".progress-circle").each(function() {

        var value = $(this).attr('data-value');
        var left  = $(this).find('.progress-left .progress-bar');
        var right = $(this).find('.progress-right .progress-bar');

        if (value > 0) {
            if (value <= 50) {
                right.css('transition', '2s ease-in-out');
                right.css('transform', 'rotate(' + percentageToDegrees(value) + 'deg)');
            } else {
                right.css('transform', 'rotate(180deg)')
                left.css('transition', '2s ease-in-out');
                left.css('transform', 'rotate(' + percentageToDegrees(value - 50) + 'deg)')
            }
        }

    });

    // Tạo 2 thanh scroll
    $('.js_top_scroll_bar').on('scroll', function (e) {
        $('.js_bottom_scroll_bar').scrollLeft($('.js_top_scroll_bar').scrollLeft());
    });
    $('.js_bottom_scroll_bar').on('scroll', function (e) {
        $('.js_top_scroll_bar').scrollLeft($('.js_bottom_scroll_bar').scrollLeft());
    });

});

$(window).on('load', function (e) {
    $('.js_top_bar').width($('.js_table_scroll').width());
    setTimeout(function (){
        if ($('.js_window_load_schedule_scroll_to').length > 0){
            let scrollTo = $('.js_window_load_schedule_scroll_to').val();
            if (scrollTo !== ''){
                $('.js_top_scroll_bar').scrollTo($('#schedule_'+scrollTo).offset().left - 800, 800);
            }
        }
    },10);
});

window.date_range_picker = function (){
    date_range = $('.date_range');
    date_range.daterangepicker({
        autoUpdateInput: false,
        "alwaysShowCalendars": true,
        "showCustomRangeLabel": false,
        "autoApply" : true,
        "locale": {
            format: "DD/MM/YYYY",
            applyLabel: "Chọn",
            cancelLabel: "Hủy",
            daysOfWeek: [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        },
    });
    date_range.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        let show_element = $(this).attr('show-target');
        if ($(show_element).length > 0){
            $(show_element).html(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        }
    });

    date_range.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.date_range_report_picker = function (){
    date_range = $('.date_range_report');
    date_range.daterangepicker({
        autoUpdateInput: false,
        "alwaysShowCalendars": true,
        "showCustomRangeLabel": false,
        "autoApply" : false,
        "locale": {
            format: "DD/MM/YYYY",
            applyLabel: "Lọc",
            cancelLabel: "Hủy",
            daysOfWeek: [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        },
    });
    date_range.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        let show_element = $(this).attr('show-target');
        if ($(show_element).length > 0){
            $(show_element).html(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        }
        $(this).parents('form').submit();
    });

    date_range.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.date_range_filter_option = function (){
    date_range = $('.date_range_filter_option');
    date_range.daterangepicker({
        autoUpdateInput: false,
        "alwaysShowCalendars": true,
        "showCustomRangeLabel": false,
        "autoApply" : true,
        "locale": {
            format: "DD/MM/YYYY",
            applyLabel: "Lọc",
            cancelLabel: "Hủy",
            daysOfWeek: [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        },
    });
    date_range.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        let show_element = $(this).attr('show-target');
        if ($(show_element).length > 0){
            $(show_element).html(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        }
        $(this).parents('form').submit();
    });

    date_range.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

function date_range_picker_full(){
    "use strict";
    var date_range_full = $('.date_range_full');
    date_range_full.daterangepicker({
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        showCustomRangeLabel: true,
        autoApply: true,
    });

    date_range_full.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
    });

    date_range_full.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.date_range_picker_single = function (){
    "use strict";
    var sing_date = $('.date_range_single');
    sing_date.daterangepicker({
        autoUpdateInput: false,
        singleDatePicker: true,
        autoApply:true,
        "locale": {
            "format": "DD/MM/YYYY",
            "applyLabel": "Chọn",
            "cancelLabel": "Hủy",
            "daysOfWeek": [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        }
    });

    sing_date.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    sing_date.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.date_range_picker_single_min_date = function (){
    "use strict";
    var sing_date = $('.date_range_single_min_date');
    sing_date.daterangepicker({
        autoUpdateInput: false,
        singleDatePicker: true,
        autoApply:true,
        minDate: moment($('.date_range_single_min_date').attr('minDate'), "DD-MM-YYYY"),
        "locale": {
            "format": "DD/MM/YYYY",
            "applyLabel": "Chọn",
            "cancelLabel": "Hủy",
            "daysOfWeek": [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        }
    });

    sing_date.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    sing_date.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.date_range_picker_single_time_picker = function (){
    var sing_date = $('.date_range_single_time_picker');
    sing_date.daterangepicker({
        showDropdowns: true,
        timePicker: true,
        //timePicker24Hour: false,
        autoUpdateInput: false,
        singleDatePicker: true,
        autoApply: true,
        "locale": {
            "format": "DD/MM/YYYY hh:mm",
            "applyLabel": "Chọn",
            "cancelLabel": "Hủy",
            "daysOfWeek": [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        }
    });

    sing_date.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY hh:mm'));
    });

    sing_date.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.date_range_picker_single_dropdown = function (){
    var sing_date = $('.date_range_single_dropdown');
    sing_date.daterangepicker({
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        autoApply:true,
        "locale": {
            "format": "DD/MM/YYYY",
            "applyLabel": "Chọn",
            "cancelLabel": "Hủy",
            "daysOfWeek": [
                "CN",
                "T2",
                "T3",
                "T4",
                "T5",
                "T6",
                "T7"
            ],
            "monthNames": [
                "Tháng 1",
                "Tháng 2",
                "Tháng 3",
                "Tháng 4",
                "Tháng 5",
                "Tháng 6",
                "Tháng 7",
                "Tháng 8",
                "Tháng 9",
                "Tháng 10",
                "Tháng 11",
                "Tháng 12"
            ]
        }
    });

    sing_date.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    sing_date.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
}

window.markNotificationAsReadAll = function (){
    $('.js_count_unread').hide();
    $('.js_repeat_count_unread').text(0);
    $('.js_notification_list').html('<p class="m-0 p-2 text-center">Không có thông báo mới nào</p>');
    $.post('/notification/mark-as-read-all');
}

window.markNotificationAsReadById = function (id){
    $.post('/notification/mark-as-read-id?id='+id);
}

window.copyToClipboard = function (obj,text) {
    if (!navigator.clipboard) {

        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
            $('.tooltip-inner').text('Copy thành công')
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);

        return;
    }

    navigator.clipboard.writeText(text).then(function() {
        $('.tooltip-inner').text('Copy thành công')
        console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

window.percentageToDegrees = function (percentage) {
    return percentage / 100 * 360;
}

window.counterNumber = function(element, number){
    $(element).prop('counter',0).animate({ counter: number }, {
        duration: 500,
        step: function(now){
            $(this).text(Math.ceil(now));
        }
    });
};

